import { 
  dataService as sharedDataService
} from '@watchlist/shared';

// Re-export the shared data service for backward compatibility
export const dataService = sharedDataService; 